import { Progress, Tooltip } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { formatNumber } from "src/utils/helper/functions";

type TopHoldingProps = {
  assets: any;
};

const TopHolding: React.FC<TopHoldingProps> = ({ assets }: TopHoldingProps) => {
  const [sortedAssets, setSortedAssets] = useState<any>([]);

  useEffect(() => {
    setSortedAssets(
      assets?.sort(
        (a: any, b: any) => b.reportingMarketAmount - a.reportingMarketAmount
      )
    );
  }, [assets]);

  return (
    <div className="h-full p-4 rounded-xl bg-white slide-bottom add-shadow border border-[#e3e3e3] flex-col justify-start items-start gap-5 inline-flex">
      <div className="Frame576270 self-stretch justify-center items-center gap-3 inline-flex">
        <div className=" grow shrink basis-0 self-stretch opacity-90 text-[#2a2a2a] text-sm md:text-base font-bold">
          Top holdings
        </div>
      </div>
      <div className=" self-stretch  overflow-auto  flex-col justify-start items-start gap-[10px] flex">
        {sortedAssets
          ?.filter(
            (asset: any) =>
              asset?.assetLiabilityCode === "A" &&
              asset?.productGroupCode !== "CSH"
          )
          ?.sort(
            (a: any, b: any) =>
              b.reportingMarketAmount - a.reportingMarketAmount
          )
          ?.slice(0, 10)
          ?.map((asset: any, index: number) => (
            <div
              key={index}
              className=" self-stretch flex-col justify-start items-end gap-1 flex pe-3"
            >
              <div className="KamcoPremier self-stretch text-[#0d1b2a] text-xs md:text-[15px] font-medium">
                {asset?.secNameEn}
              </div>
              <div className=" self-stretch justify-between items-start inline-flex">
                <div className="000Kwd text-[#778da9] text-[10px] md:text-[13px] font-medium">
                  {formatNumber(asset?.reportingMarketAmount)}{" "}
                  {asset?.reportingCurrency}
                </div>
                <div className="000Kwd text-[#778da9] text-[10px] md:text-[13px] font-medium">
                  {moment(asset.positionDate).format("MMM DD, YYYY")}
                </div>
              </div>
              <Tooltip
                title={
                  asset.unrealPercentage >= 0
                    ? `Gain ${asset.unrealPercentage}%`
                    : `Loss (${Math.abs(asset.unrealPercentage)}%)`
                }
              >
                <Progress
                  percent={Math.abs(asset.unrealPercentage)}
                  strokeColor={
                    asset.unrealPercentage > 0 ? "#3eb7ed" : "#F5606F"
                  }
                  className="w-full"
                  showInfo={false}
                />
              </Tooltip>
            </div>
          ))}
      </div>
      <div className="hidden self-stretch">
        <span className="text-[#778da9] text-[10px] md:text-[13px] font-normal leading-[0px] md:leading-[16.90px]">
          This month you saved 8% more than the previous month. Use{" "}
        </span>
        <span className="text-[#002f6c] text-[10px] md:text-[13px] font-normal underline leading-[0px] md:leading-[16.90px]">
          Tips
        </span>
        <span className="text-[#778da9] text-[10px] md:text-[13px] font-normal leading-[0px] md:leading-[16.90px]">
          {" "}
          to achieve your goals faster
        </span>
      </div>
    </div>
  );
};

export default TopHolding;
